import { Component, Input, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-video-background',
  templateUrl: './video-background.component.html',
  styleUrls: ['./video-background.component.scss']
})
export class VideoBackgroundComponent implements AfterViewInit {
  @Input() videoSrc: string;
  video;

  constructor(
    public el: ElementRef
  ) { }

  ngAfterViewInit() {
    this.video = this.el.nativeElement.querySelector('video');

    this.video.addEventListener('oncanplay', this.playVideo(), false);
    this.video.addEventListener('onloadedmetadata', this.muteVideo(), false);
  }

  playVideo() {
    this.video.play().catch(err => {
      console.log(err);
    });
  }

  muteVideo() {
    this.video.muted = true;
  }
}
